export default "__VITE_ASSET__CpCj1sin__"